import React, { ReactChild, HTMLAttributes } from 'react'

export interface ITableFooterProps extends HTMLAttributes<any> {
  children: ReactChild | ReactChild[];
}

export default function TableFooter({children, ...props}: ITableFooterProps) {
  return (
    <tfoot {...props}>
      {children}
    </tfoot>
  )
}
